<template>
  <div class="bg-white">
    <div :id="routeName" :style="{ height: chartHeight + 'px' }">

    </div>
  </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {amchartsMixin} from "@/mixins/amchartsMixin";
import axios from "axios";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";


export default {

  name: "DashboardPointBreakdown",
  components: {},
  mixins: [SonicuCoreMixin, amchartsMixin],
  props: {
    newRoute: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: {},
      loading: false,
    }
  },
  created() {
    // Non-reactive: this holds a live am5 chart. Vue's reactive() proxies
    // deeply, and am5 detaches a child's canvas display by === identity, so an
    // am5 object that exists as both a raw object and a proxy never gets
    // removed from its parent's display list and keeps painting as a ghost.
    // See the note in Am5Series' constructor.
    this.chart = null
  },
  mounted() {
    this.initializeAM5Charts()
    this.loadData();
  },
  methods: {
    makeChart() {
      if (this.chart !== null) {
        this.chart.dispose();
      }

      let root = am5.Root.new(this.routeName);

      let chart = root.container.children.push(
          am5xy.XYChart.new(root, {
            paddingRight: 60,
          })
      );

      let yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
        categoryField: "type",
        renderer: am5xy.AxisRendererY.new(root, {
          minGridDistance: 20,
        }),
      }));
      yAxis.get('renderer').grid.template.set('forceHidden', true); // Hide grid lines
      yAxis.data.setAll(this.data);

      let xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
        visible: false,
        extraMax: 0.15,
        renderer: am5xy.AxisRendererX.new(root, {}),
      }));
      xAxis.get('renderer').grid.template.set('forceHidden', true); // Hide grid lines

      let series = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: "Point Breakdown",
            xAxis: xAxis,
            yAxis: yAxis,
            valueXField: "number",
            categoryYField: "type",
            fill: am5.color("#3d81f7"),
            opacity: 0.8,
          })
      );

      series.columns.template.setAll({
        height: 30,
        tooltipText: "{valueX} {categoryY} points"
      })

      series.data.setAll(this.data);

      const BULLET_RADIUS = 15;
      series.bullets.push((root) => {
            return am5.Bullet.new(root, {
              locationX: 1,
              locationY: 0.5,
              sprite: am5.Circle.new(root, {
                dx: BULLET_RADIUS + 10,
                radius: 15,
                stroke: am5.color("#3d81f7"),
                strokeOpacity: 0.4,
                strokeWidth: 1
              })
            })
          }
      );

      series.bullets.push((root) => {
            return am5.Bullet.new(root, {
              locationX: 1,
              locationY: 0.5,
              sprite: am5.Label.new(root, {
                dx: BULLET_RADIUS + 10,
                text: "{valueX}",
                centerX: am5.percent(50),
                centerY: am5.percent(50),
                textAlign: "center",
                populateText: true,
              })
            })
          }
      );

      chart.plotContainer.set("maskContent", false);

      this.chart = chart
    },
    loadData() {
      this.loading = true;
      axios.get(this.company.buildCompanyApiInternalRoute(this.routeName)).then(
          response => {
            this.data = []
            Object.keys(response.data).forEach(key => {
              if(response.data[key] === 0) {
                return
              }
              this.data.push({
                type: key,
                number: response.data[key],
              })
            })
            this.loading = false
            this.makeChart()
          }
      );
    }
  },
  computed: {
    totalPoints() {
      let sum = 0
      Object.keys(this.data).forEach(key => {
        sum += this.data[key]
      })
      return sum
    },
    chartHeight() {
      const itemCount = Array.isArray(this.data) ? this.data.length : 0;
      return Math.max(200, itemCount * 45 + 40);
    },
    routeName() {
      if(this.newRoute.length > 0){
        return this.newRoute;
      } else {
        return 'dashboard/point-breakdown';
      }
    },
  },
  beforeUnmount() {
    this.chart.dispose()
  },
}
</script>

<style scoped>

</style>